export function getView(contract, signature_request) {
  return contract.signed_date ||
    !signature_request ||
    signature_request.status !== 'pending'
    ? 'Empty'
    : 'Content'
}
